<template>
  <vs-popup class="" :title="$t('ImagePreview')" :active.sync="showModal">
    <div class="w-1/6">
      <img
        :src="URLS_CONSTANTS.assets + 'PackageAttachments/' + model"
        class="block mx-auto w-full my-0 text-center"
      />
    </div>
  </vs-popup>
</template>
<script>
import { URLS_CONSTANTS } from "../../../../config";
export default {
  props: {
    show: { default: false },
    model: {
      default: {}
    }
  },
  computed: {
    showModal: {
      get: function() {
        return this.show;
      },
      set: function() {
        this.$emit("finish");
      }
    }
  },
  data() {
    return {
      URLS_CONSTANTS: URLS_CONSTANTS
    };
  },
};
</script>
